import { PayloadAction } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { authReducer } from './auth/auth.reducer';
import { AUTH_ACTION_TYPES } from './auth/auth.types';
import { dialogReducer } from './dialog/dialog.reducer';
import { errorReducer } from './error/error.reducer';
import { loadingReducer } from './loading/loading.reducer';
import { nodeReducer } from './node/node.reducer';
import { projectReducer } from './project/project.reducer';

const appReducer = combineReducers({
    loading: loadingReducer,
    error: errorReducer,
    dialog: dialogReducer,
    auth: authReducer,
    project: projectReducer,
    node: nodeReducer,
});

export const rootReducer = (state: any, action: PayloadAction) => {
    if (action.type === AUTH_ACTION_TYPES.SIGN_OUT) {
        state = undefined;
    }


    return appReducer(state, action);
};
